import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import CurrencyModel from "../../../model/currency.model";
import CurrencyService from "../../../api/currency/currency.service";
import {Observable} from "rxjs";

@Component({
  selector: 'app-currency-input',
  templateUrl: './currency-input.component.html',
  styleUrls: ['./currency-input.component.scss']
})
export class CurrencyInputComponent implements OnInit, AfterViewInit {
  @Input() value: number;
  @Input() disabled = false;
  @Input() currency: CurrencyModel;

  @Output() valueChanged = new EventEmitter<number>();
  @Output() currencyChanged = new EventEmitter<CurrencyModel>();

  public currencies$: Observable<CurrencyModel[]>;

  constructor(public currencyService: CurrencyService) {
    this.currencies$ = this.currencyService.currencies$;
  }

  ngOnInit(): void {
  }

  changedValue() {
    this.valueChanged.emit(this.value);
  }

  changedCurrency() {
    console.log('emit currency', this.currency);
    this.currencyChanged.emit(this.currency);
  }

  ngAfterViewInit() {
    console.log(this.currency);
    if(!this.currency || typeof this.currency.code == 'undefined') {
      this.currencies$.subscribe(currencies => {
        console.log(currencies);
        for (let c of currencies) {
          if(c.code == 'EUR') {
            this.currency = JSON.parse(JSON.stringify(c));
            this.changedCurrency();
            return;
          }
        }
      });
    }
  }
}
